import { Component, OnInit, Input } from '@angular/core';
import { BcAccountClientService } from '../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
	selector: 'app-bc-e-committee',
	templateUrl: './bc-e-committee.component.html',
	styleUrls: ['./bc-e-committee.component.scss']
})
export class BcECommitteeComponent implements OnInit {

	constructor(private bcAccountClientService: BcAccountClientService, private flashMessagesService: FlashMessagesService) { }

	@Input("proposalID") proposalID;

	private comitteeData;
	private userID;
	private novasLiberacoes = null;
	private comentario = null;
	private juros = null;

	public isLoaded = false;

	ngOnInit() {
		this.userID = localStorage.getItem('yara.userID');
		this.loadExtensionCommittee();
	}

	loadExtensionCommittee() {
		if (!this.isLoaded) {
			this.getExtensionCommittee();
			this.isLoaded = true;
		} 
	}

	getExtensionCommittee() {
		this.bcAccountClientService.getExtensionCommittee(this.proposalID).subscribe(result => {
			if (result.Success) {
				this.comitteeData = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-success', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

	onSave(approve, index) {
		const objToSend = {
			FluxoID: this.comitteeData[index].ID,
			NovasLiberacoes: this.novasLiberacoes,
			Aprovado: approve,
			Comentario: this.comentario,
			TaxaJuros: this.juros,
			PropostaProrrogacaoID: this.proposalID
		}

		this.bcAccountClientService.saveExtensionApproval(objToSend).subscribe(result => {
			if (result.Success) {
				this.getExtensionCommittee();
				if (this.comitteeData[this.comitteeData.length - 1].Nivel == this.comitteeData[index].Nivel) {
					this.bcAccountClientService.proposalChanged.next();
					this.bcAccountClientService.billingChaged.next();
					this.flashMessagesService.show("Proposta alterada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				}
				this.flashMessagesService.show("Fluxo de comitê salvo com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
				this.comentario = null;
				this.novasLiberacoes = false;
				this.juros = null;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-extension-proposal/bc-e-committee/bc-e-committee.component.ts